import { generateRoutesWithTitle } from "@/helpers/generateRoutesWithTitle";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "../App";
import { routes } from "./routes";

const routesWithTitles = generateRoutesWithTitle(routes);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: routesWithTitles,
  },
]);

export const AppRouterProvider = () => <RouterProvider router={router} />;
